import React, { ReactElement, ReactNode } from 'react';
import './MaintenanceMobileTab.scss';

type Props = {
  title: string;
  children?: ReactNode;
  icon?: ReactElement
  onClick?: ()=> void
  disabled?: boolean
  activeParam?: string
};

const MaintenanceMobileTab: React.FC<Props> = (props) => {
  return (
    <div>
      {props.children}
    </div>
  );
};

export default MaintenanceMobileTab;
